import Vue from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import $ from 'jquery'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import {dom} from '@fortawesome/fontawesome-svg-core'

// Watches DOM and converts <i> icons to svg's
dom.watch();

$.fn.datetimepicker.defaults.icons = {
  time: 'fas fa-clock',
  date: 'fas fa-calendar',
  up: 'fas fa-arrow-up',
  down: 'fas fa-arrow-down',
  previous: 'fas fa-arrow-left',
  next: 'fas fa-arrow-right',
  today: 'fas fa-crosshairs',
  clear: 'fas fa-times',
  close: 'fas fa-arrow-up',
};

Vue.use(datePicker);
